import React from 'react';
import './App.css';
import FormEditorPreview from './FormEditorPreview';

function App() {
  return (
    <div className="App">
      <h1>Form.io Editor POC</h1>
      <FormEditorPreview />
    </div>
  );
}

export default App;
